import { z } from "zod";
import { meaningCandidateSchema } from "../ai/schemas.ts";

export const DISCOVER_CACHE_SCHEMA_VERSION = 1 as const;
export const DISCOVER_CACHE_CANDIDATE_LIMIT = 24;
export const DISCOVER_CACHE_ENTRY_LIMIT = 80;

export const discoverCacheEntrySchema = z.object({
  candidates: z.array(meaningCandidateSchema).min(1).max(DISCOVER_CACHE_CANDIDATE_LIMIT),
  moreAvailable: z.boolean(),
  corrections: z.array(z.string()),
});

export const discoverCacheEnvelopeSchema = z
  .object({
    schemaVersion: z.literal(DISCOVER_CACHE_SCHEMA_VERSION),
    entries: z.record(z.string(), discoverCacheEntrySchema),
  })
  .strict();

export type DiscoverCacheEntry = z.infer<typeof discoverCacheEntrySchema>;
export type DiscoverCacheEnvelope = z.infer<typeof discoverCacheEnvelopeSchema>;
